// Before Create (Phase 4, item 7): every field the copy uses must be filled for every person.
// Lists exactly who lacks what, with one click to fill it (Scout writes personal lines) or to
// take the field out of the copy.
import type { SequenceMissingField, SequenceStep } from '../api/types';
import { MAX_PERSONAL_LINES_PER_FILL, PERSONAL_LINE_FIELD, fieldInTag, missingFieldGroups } from '../lib/sequenceBuilder';

export function SequenceFieldCheck({ missing, steps, busy, onFill, onRemove }: {
  missing: SequenceMissingField[];
  steps: SequenceStep[];
  busy: boolean;
  onFill: (contactIds: string[]) => void;
  onRemove: (field: string) => void;
}) {
  const groups = missingFieldGroups(missing);
  if (!groups.length) return null;
  return (
    <div className="pushresult warn">
      <div>Not ready: some people are missing fields the copy uses.</div>
      {groups.map(group => (
        <div className="pushrows" key={group.field}>
          <span className="seqhint">{`{{${group.field}}}`} is empty for {group.names.join(', ')}</span>
          <div className="seqrow">
            {group.field === PERSONAL_LINE_FIELD ? (
              <button type="button" className="pushchip" disabled={busy} onClick={() => onFill(group.contactIds)}>
                Fill with Scout
              </button>
            ) : null}
            {fieldInTag(steps, group.field) ? (
              <span className="seqhint">{'Used in a {% %} tag: edit that step.'}</span>
            ) : (
              <button type="button" className="brieftoggle" disabled={busy} onClick={() => onRemove(group.field)}>
                Remove the field
              </button>
            )}
          </div>
          {group.field === PERSONAL_LINE_FIELD && group.contactIds.length > MAX_PERSONAL_LINES_PER_FILL ? (
            <span className="seqhint">Scout writes up to {MAX_PERSONAL_LINES_PER_FILL} lines per click.</span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
